import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spinner } from "@air/primitive-spinner";
import { memo } from "react";
export const TranscriptProcessing = /*#__PURE__*/ memo(()=>{
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex grow flex-col items-center gap-4 py-8",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "flex items-center justify-center text-teal-9",
                children: /*#__PURE__*/ _jsx(Spinner, {})
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "text-center text-12 text-grey-11",
                children: "Transcript is currently being captured from this file"
            })
        ]
    });
});
TranscriptProcessing.displayName = "TranscriptProcessing";
